<template>
  <!-- class="el-main-1" -->
  <div  class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-row type="flex">
      <el-col :span="5">
        <div style="background-color:#fff">
          <div style="text-align: left; height: 60px;  color: #0162c3 ; margin-left: 10px; font-weight: bold; display: flex ;align-items: center; ">
            <i class="el-icon-position"> </i>安全责任书
          </div>
          <el-menu default-active="1" style="background-color:rgb(124, 203, 199)">
            <el-menu-item index="1" style="margin: 0px; font-size: 20px; ">全部</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="19" style="margin-left:50px">
        <div style="background-color:#fff; " >
          <el-breadcrumb separator="/"  style="height:60px;margin-left: 10px; font-size:20px; display: flex ;align-items: center;">
            <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
            <el-breadcrumb-item >安全责任书</el-breadcrumb-item>
            <el-breadcrumb-item >全部</el-breadcrumb-item>
          </el-breadcrumb>
          <el-divider></el-divider>
          <div>
            <div class="tzgg-ul">
              <el-card v-for = " (item,index) in tableData" :key="item.id" style=" width: 95%;margin-left: 10px;margin-top: 10px; height: 100px; text-align: left;">
                <div style="display: flex; align-items: center;">  
                  <el-tag  style ="display:inline-block" v-if = "item.fileTreeId == null || item.fileTreeId == ''"  effect="dark" size="mini" type="danger">未签名</el-tag>
                  <el-tag  style ="display:inline-block"  v-else effect="dark" size="mini" type="success">已签名</el-tag>
                  <span style ="display:inline-block;width: 80%; margin-left: 10px; overflow: hidden;text-overflow: ellipsis; white-space: nowrap;"> {{index  + 1 }}.主题: {{item.theme }}</span> 
                  <!-- 并且自己考试时间用完 -->
                  <el-button   type = "warning" size="mini"  @click="routeFuncDetail(item.id)"  
                    v-if = "item.fileTreeId == null || item.fileTreeId == '' ">  
                    去签名
                  </el-button>  
                  <!-- <el-button v-if = "item.fileTreeId != null && item.fileTreeId != ''" @click="saveSafeBook(item)"  
                    size="mini" type = "success" > 
                    下载
                  </el-button>
                  <el-button v-if = "item.fileTreeId != null &&  item.fileTreeId != ''"   @click="printSafeBook(item)"  
                    size="mini" type = "warning" > 
                    打印
                  </el-button> -->
                  <i v-if = "item.fileTreeId != null && item.fileTreeId != ''" style="margin-left:10px; color: rgb(43, 255, 0);cursor:pointer" class=" el-icon-download "  @click="saveSafeBook(item)"></i>
                  <!-- <el-button   type = "primary"  size="mini" @click="printZs(item)" >
                    打印证书
                  </el-button> -->
                  <i v-if = "item.fileTreeId != null && item.fileTreeId != ''" class="el-icon-printer " style="margin-left:10px;color: rgb(0, 21, 255); cursor:pointer"  @click="printSafeBook(item)"></i>
                </div>
                <div style="margin-top:10px; font-size: 15px;">
                  <span>发布时间: {{ item.sendTime }}</span>  
                   <span  v-if = "item.fileTreeId != null && item.fileTreeId != ''">签名时间: {{ item.signTime }}</span>
                </div>
              </el-card>
            </div>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pager.pageSize"
            :total="pager.totalCount" style="margin-top : 20px; margin-bottom: 20px;">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- v-if = "safeBook.safeBookImage == null || safeBook.safeBookImage == ''" -->
    <el-dialog :visible.sync="dialogVisual.safeBook" fullscreen  v-on:close ="clearSafeBook">
      <div v-if = "safeBook.safeBookImage == null || safeBook.safeBookImage == ''" class = "w-e-text-container" ref="canvasDom" style="width:1000px;margin:auto">
        <div>
          <el-image :src = "logo2" style="width:300px; height: 55px; margin:20px">
          </el-image>
          <el-divider ></el-divider>
          <div data-slate-editor style="overflow:auto !important; margin: auto; width:1000px;height: 1200px;" v-html="safeBook.content">
          </div>
          <div style="text-align: right; margin-top: 10px; margin-right: 20px;">
            <div style="height:60px;display: flex; margin-left: 60%; ">
              <span>责任人:</span> 
              <el-image :src ="safeBook.fileUrl" fit ="cover" :width= "30" :height="10"> 
              </el-image>
            </div>
            <div style="height:30px;display: flex; margin-left: 60%; ">
              <span>签名日期:</span> 
              <span> {{safeBook.signTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="margin:auto;width:1000px;" id ="safeBookImage">
        <img :src = "safeBook.safeBookImage"  style="margin:20px;width:1000px; max-height: 1520px"/> 
      </div>
    </el-dialog> 
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import logo2 from "@/assets/image/logo2.jpg"
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
import html2canvas from 'html2canvas'
import SERVICE_URL  from  '@/api/url'
export default {
  name : 'pc_notice',
  data() {
    return {
      logo2,
      tableData:[],
      dialogVisual :{
        safeBook : false
      },
      safeBook : {
        content :'',
        fileUrl :'',
        signTime:'',
        safeBookImage :''
      },
      pager:{
        totalCount:0,
        pageSize : 5                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
      },
    
    }
  },
  methods : {
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },

    routeFuncDetail( id){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open( SERVICE_URL +"/#/pc_editor_view/" +id +"?fileType=" + fileType.SAFE_BOOK,"test",params0);
    },
    handleCurrentChange(val){
      this.safeBookListLoad(val);
    },
    clearSafeBook(){
      this.safeBook.content = ''
      this.safeBook.fileUrl  = ''
      this.safeBook.safeBookImage = ''
      this.safeBook.signTime = ''
    },
    safeBookListLoad(pageNo){
      let url = "/bc/exa/safeBook/selectUserSafeBookPage"
      let dat = {
        student:true,
        pageNo,
        pageSize: 5,
        active: 1
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.tableData.splice(0)
            response.data.data.data.forEach(t=>{
              this.tableData.push(t)
            })
            this.pager.totalCount = response.data.data.totalDataCount
          }else{
            this.$message({
              showClose: true,
              message: '未查询到安全责任书信息！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },

    printSafeBook(item){
      this.dialogVisual.safeBook = true
      this.safeBook.content = item.content
      this.safeBook.fileUrl = item.signImage
      this.safeBook.signTime = item.signTime
      setTimeout(()=>{ 
        const canvasDom = this.$refs.canvasDom
        html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1000
        }).then((canvas) => {
          this.safeBook.safeBookImage = canvas.toDataURL('image/png')
          setTimeout(()=>{
            const content = document.getElementById('safeBookImage').innerHTML
            var newWindow = window.open('', '打印窗口');
            newWindow.document.write('<html><head><title>安全责任书</title></head><body>' + content + '</body></html>');
            newWindow.document.close();
            newWindow.print();
            newWindow.close();
          },300)
        }).catch((e) => {
          this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })},300)
    },
    saveSafeBook(item){
      this.dialogVisual.safeBook = true
      this.safeBook.content = item.content
      this.safeBook.fileUrl = item.signImage
      this.safeBook.signTime = item.signTime
      setTimeout(()=>{ 
      const canvasDom = this.$refs.canvasDom
      html2canvas(canvasDom, {
          dpi: 300, // 解决生产图片模糊
          useCORS: true,
          allowTaint: false,
          logging: false,
          scale: 2,
          windowHeight: 1000
        }).then((canvas) => {
            this.safeBook.safeBookImage = canvas.toDataURL('image/png')
            let a = document.createElement("a");
            document.body.appendChild(a)
            a.setAttribute("download", `安全责任书_${item.theme}.png`);
            a.setAttribute("href", this.safeBook.safeBookImage);
            a.click();
            document.body.removeChild(a)
        }).catch((e) => {
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })},300)
      }
    },
    created(){
      setTimeout(()=>{ this.safeBookListLoad(1) },200)
    },
    components: {
    }
  }
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  // background-color:rgb(130, 20, 20);
  // background-color:#f9fafc;
  color: #333;
  height: 99%;
  overflow:auto;
}

.el-row {
  padding: auto;
  margin: auto;
  height: 300px;
  width: 1400px;
  font-size: large;
  text-align: center;
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 1px 0;
  width: 100%
}
</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_safe_book.vue